import React from "react";
import Lottie from "react-lottie";

import "./VisualLottieShowcase.scss";

interface VisualLottieShowcaseProps {
  title?: string;
  description?: string;
  animationOne?: {};
  animationTwo?: string;
  layout?: "full" | "centered" | "split";
  titleColor?: string;
  descriptionColor?: string;
  backgroundColor?: string;
}

export function VisualLottieShowcase({
  title,
  animationOne,
  animationTwo,
  backgroundColor,
  titleColor,
  descriptionColor,
  description,
  layout,
}: VisualLottieShowcaseProps) {
  const layoutClass = layout === "centered" ? "layoutCentered" : "layoutFull";

  const defaultOptionsAnimationOne = {
    loop: true,
    autoplay: true,
    animationData: animationOne,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="visualShowcase" style={{ backgroundColor }}>
      <div className="showcaseContainer">
        {(title || description) && (
          <div className="showcaseHeader">
            {title && (
              <h2 className="showcaseTitle" style={{ color: titleColor }}>
                {title}
              </h2>
            )}
            {description && (
              <p
                className="showcaseDescription"
                style={{ color: descriptionColor }}
              >
                {description}
              </p>
            )}
          </div>
        )}
        <div className={`showcaseImageWrapper ${layoutClass}`}>
          <div className="showcaseImageContainer">
            {/* <img src={imageUrl} alt={imageAlt} className="showcaseImage" /> */}
            <Lottie options={defaultOptionsAnimationOne} />
          </div>
        </div>
      </div>
    </section>
  );
}
